import { Mail, Phone } from "lucide-react";
import { useApi, waLink } from "@/lib/api";
import { Seo } from "@/components/site/Seo";
import { PageHeader } from "@/components/site/Reveal";
import { InquiryForm } from "@/components/site/InquiryForm";
import { Socials } from "@/components/site/Navbar";
import { useLang } from "@/lib/i18n";

export default function Contact() {
  const { t, L } = useLang();
  const { data: s } = useApi("/settings");
  return (
    <>
      <Seo title={t("contact.seoTitle")} description={t("contact.seoDesc")} />
      <PageHeader testId="contact-header" eyebrow={t("contact.eyebrow")} title={t("contact.title")}>
        {t("contact.intro")}
      </PageHeader>
      <section className="container-x grid gap-12 pb-28 lg:grid-cols-12">
        <div className="space-y-6 lg:col-span-5">
          <div className="rounded-2xl border border-clay bg-linen p-8">
            <h2 className="font-display text-2xl font-black text-ink">{t("detail.contact", { name: s?.contact_name || "" })}</h2>
            <a href={`mailto:${s?.contact_email}`} className="mt-5 flex items-center gap-3 font-bold text-forest hover:underline" data-testid="contact-page-email"><Mail className="h-5 w-5" />{s?.contact_email}</a>
            {s?.contact_whatsapp && <a href={waLink(s.contact_whatsapp)} target="_blank" rel="noreferrer" className="mt-3 flex items-center gap-3 font-bold text-forest hover:underline" data-testid="contact-page-whatsapp"><Phone className="h-5 w-5" />{t("common.telWa")}: {s.contact_phone_display}</a>}
            <p className="mt-5 text-sm font-semibold text-moss">{L(s, "broker_license")}</p>
            <Socials className="mt-6 text-forest" />
          </div>
        </div>
        <div className="rounded-2xl border border-clay p-8 lg:col-span-7"><InquiryForm /></div>
      </section>
    </>
  );
}
